import { createAsyncThunk } from '@reduxjs/toolkit';

import api from '../../../api/apiServises';
import {
  ADD_PAINT_DATA,
  GET_PAINT,
  GET_VIEW_PAINT,
  PAINT_HISTORY,
  UPDATE_PAINT_FLOW,
  PAINT_REPORT,
  DELETE_PAINT_INSPECTION_DATA,
  FETCH_PAINT_INSULATION_DATA,
  ADD_THERMAL_INSULATION,
  LIST_THERMAL_INSULATION,
  VIEW_THERMAL_INSULATION,
  UPDATE_THERMAL_FLOW_STATUS,
  HISTORY_THERMAL_INSULATION,
  PAINT_DASHBOARD,
} from '../../../api/apiConstant';

export const addPaintData = createAsyncThunk(
  'material/addPaintData',
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.post(ADD_PAINT_DATA, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.response?.data ||
          error.message ||
          'Failed to add paint data',
      );
    }
  },
);

export const fetchPaintForm = createAsyncThunk(
  'underFrame/fetchPaintForm',
  async (formData, { rejectWithValue }) => {
    console.log(27, formData);
    try {
      const response = await api.get(GET_PAINT, { params: { ...formData } });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Failed to fetch Paint Data');
    }
  },
);

export const fetchViewPaintForm = createAsyncThunk(
  'paint/fetchViewPaintForm',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(GET_VIEW_PAINT, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Failed to fetch Paint Data');
    }
  },
);

export const fetchPaintByShellDetails = createAsyncThunk(
  'paint/fetchByShellDetails',
  async ({ shellType, shellNo }, { rejectWithValue }) => {
    try {
      const response = await api.get(
        `/api/paint/by-shell?shell_type=${shellType}&shell_no=${shellNo}`,
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const UpdatePaintFlowStatus = createAsyncThunk(
  'paint/UpdatePaintFlowStatus',
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.post(UPDATE_PAINT_FLOW, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.response?.data ||
          error.message ||
          'Failed to update status',
      );
    }
  },
);

/* Paint History */
export const paintHistory = createAsyncThunk(
  'paint/paintHistory',
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.get(PAINT_HISTORY, { params: data });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.response?.data ||
          error.message ||
          'Failed to get paint history',
      );
    }
  },
);

/* Paint Report */
export const fetchPaintReport = createAsyncThunk(
  'paint/fetchPaintReport',
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.post(PAINT_REPORT, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.response?.data ||
          error.message ||
          'Failed to get paintreport',
      );
    }
  },
);

export const deletePaintInspection = createAsyncThunk(
  'furnishing/deletePaintInspection',
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.get(`${DELETE_PAINT_INSPECTION_DATA}?id=${id}`);
      return response;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || 'Delete Failed');
    }
  },
);

export const fetchPaintInsulationData = createAsyncThunk(
  'paint/fetchPaintInsulationData',
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.get(FETCH_PAINT_INSULATION_DATA, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.response?.data ||
          error.message ||
          'Failed to get paintreport',
      );
    }
  },
);

export const addThermalInsulation = createAsyncThunk(
  'paint/addThermalSolution',
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.post(ADD_THERMAL_INSULATION, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.response?.data ||
          error.message ||
          'Failed to add thermal solution data',
      );
    }
  },
);

export const listThermalInsulation = createAsyncThunk(
  'paint/listThermalSolution',
  async (params, { rejectWithValue }) => {
    try {
      const response = await api.get(LIST_THERMAL_INSULATION, { params });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something went wrong');
    }
  },
);

export const viewThermalInsulation = createAsyncThunk(
  'paint/viewThermalInsulation',
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.post(VIEW_THERMAL_INSULATION, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.response?.data ||
          error.message ||
          'Failed to get view data',
      );
    }
  },
);

export const updateThermalFlowStatus = createAsyncThunk(
  'paint/updateThermalFlowStatus',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(UPDATE_THERMAL_FLOW_STATUS, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to update thermal insulation status',
      );
    }
  },
);

export const getHistoryThermalInsulation = createAsyncThunk(
  'paint/getHistoryThermalInsulation',
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.post(HISTORY_THERMAL_INSULATION, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.response?.data ||
          error.message ||
          'Failed to get history view data',
      );
    }
  },
);

/* Fetch Paintshop Dashboard Data */
export const fetchPaintDashboard = createAsyncThunk(
  'paint/fetchPaintDashboard',
  async (params, { rejectWithValue }) => {
    try {
      const payload = {};

      const dateFrom = params?.dateFrom ?? params?.date_from ?? params?.date ?? null;
      const dateTo = params?.dateTo ?? params?.date_to ?? params?.date ?? null;
      const shellType = params?.shellType ?? params?.shell_type;
      const appProcess = params?.appProcess ?? params?.app_process;
      const formName = params?.formName ?? params?.form_name;

      if (dateFrom) {
        payload.date_from = dateFrom;
      }

      if (dateTo) {
        payload.date_to = dateTo;
      }

      if (params?.shift) {
        payload.shift = params.shift;
      }

      if (shellType) {
        payload.shell_type = shellType;
      }

      if (appProcess) {
        payload.app_process = appProcess;
      }

      if (formName) {
        payload.form_name = formName;
      }

      console.log('📊 Sending payload to API:', payload);
      const response = await api.post(PAINT_DASHBOARD, payload);
      console.log('📊 API Response:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ API Error:', error);
      return rejectWithValue(
        error.response?.data?.message ||
          error.response?.data ||
          error.message ||
          'Failed to fetch paint dashboard data',
      );
    }
  },
);
